import Login from "../Screens/Login";
import ForgotPassword from "../Screens/ForgotPassword";
import VerifyEmail from "../Screens/VerifyEmail";
import CreatePassword from "../Screens/CreatePassword";
import SelectCountry from "../Screens/SelectCountry";
import Signup from "../Screens/Signup";
import ServiceAgreement from "../Screens/ServiceAgreement";
import { CheckEmailProceed } from "../Screens/CheckEmailProceed";
import Dashboard from "../Screens/Dashboard";
import RegisterDetails from "../Screens/RegisterDetails";
import UpdatePayment from "../Screens/UpdatePayment";
import Jobs from "../Screens/Jobs";
import JobsDetails from "../Screens/JobsDetails";
import Installations from "../Screens/SignupInstallations";
import SignupProviders from "../Screens/SignupProviders";
import Messaging from "../Screens/Messaging";
import Schedule from "../Screens/Schedule";
import Vehicles from "../Screens/Vehicles";
import Settings from "../Screens/Settings";
import PersonalInfo from "../Components/Settings/PersonalInfo";
import Credits from "../Components/Settings/Credits";
import Security from "../Components/Settings/Security";
import SettingsVehicles from "../Components/Settings/Vehicles";
import Locations from "../Components/Settings/Locations";
import PaymentMethod from "../Components/Settings/PaymentMethod";
import FAQ from "../Components/Settings/FAQ";
import Terms from "../Components/Settings/Terms";
import Notifications from "../Screens/Notifications";
import { paths } from "../constants/paths";
import Privacy from "../Components/Settings/Privacy";

export const publicRoutes = [
  { path: paths.auth.login, element: <Login /> },
  { path: paths.auth.forgotPassword, element: <ForgotPassword /> },
  { path: paths.auth.verifyEmail, element: <VerifyEmail /> },
  { path: paths.auth.createPassword, element: <CreatePassword /> },
  { path: paths.auth.selectCountry, element: <SelectCountry /> },
  { path: paths.auth.register, element: <Signup /> },
  { path: paths.auth.serviceAgreement, element: <ServiceAgreement /> },
  { path: paths.auth.checkEmailProceed, element: <CheckEmailProceed /> },
];

export const privateRoutes = [
    { path: paths.dashboard, element: <Dashboard /> },
    { path: paths.registerDetails, element: <RegisterDetails /> },
    { path: paths.updatePayment, element: <UpdatePayment /> },
    { path: paths.jobs, element: <Jobs /> },
    { path: paths.jobPayment, element: <JobsDetails /> },
    { path: paths.jobDetails, element: <JobsDetails /> },
    { path: paths.registerInstallations, element: <Installations /> },
    { path: paths.registerProviders, element: <SignupProviders /> },
    { path: paths.messaging, element: <Messaging /> },
    { path: paths.schedule, element: <Schedule /> },
    { path: paths.reschedule, element: <Schedule /> },
    { path: paths.vehicles, element: <Vehicles /> },
    {
        path: paths.settings.root,
        element: <Settings />,
        children: [
            { path: paths.settings.companyInfo, element: <PersonalInfo /> },
            { path: paths.settings.credits, element: <Credits /> }, // Credits -> Tokens
            { path: paths.settings.security, element: <Security /> },
            { path: paths.settings.vehicles, element: <SettingsVehicles /> },
            { path: paths.settings.locations, element: <Locations /> },
            { path: paths.settings.paymentMethod, element: <PaymentMethod /> },
            { path: paths.settings.faq, element: <FAQ /> },
            { path: paths.settings.terms, element: <Terms /> },
            { path: paths.settings.privacyPolicy, element: <Privacy /> },
        ],
    },
    { path: paths.notifications, element: <Notifications /> },
];
